// src/services/BlogService.js
import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
});

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
// public
export async function fetchBlogs({ page=1, limit=12, q="" } = {}) {
  const res = await API.get(`/blogs`, { params: { page, limit, q } });
  return res.data;
}
export async function fetchBlogBySlug(slug) {
  const res = await API.get(`/blogs/${slug}`);
  return res.data;
}

// admin
export async function adminListBlogs(params = {}) {
  const res = await API.get(`/blogs`, { params });
  return res.data;
}
export async function adminCreateBlog(formData) {
  // formData is FormData (multipart)
  const res = await API.post(`/blogs`, formData, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data;
}
export async function adminUpdateBlog(id, formData) {
  const res = await API.put(`/blogs/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data;
}
export async function adminDeleteBlog(id) {
  const res = await API.delete(`/blogs/${id}`);
  return res.data;
}
